"use client";
import { Button } from "cy-fe";
import type { FormEvent } from "react";
import { useState } from "react";
import { Combobox, ComboboxOption } from "@headlessui/react";
import { ComboBox, ComboOption } from "cy-ui/components/Combobox";
import * as StepWizard from "cy-ui/components/StepWizard";
import { HeaderDescription, HeaderText } from "../components/HeaderText";
import { BodyContainer } from "../components/layouts";
import { Country } from "./models";

export function CountryPage({
  initialCountry,
  countries,
  onContinue,
  backUrl,
}: {
  initialCountry?: Country;
  onContinue: (country: Country) => Promise<void>;
  countries: Country[];
  backUrl: string;
}) {
  const [submitting, setSubmitting] = useState(false);
  const [country, setCountry] = useState<Country | null>(
    initialCountry || null,
  );
  async function submitHandler(evt: FormEvent) {
    evt.preventDefault();
    if (country) {
      setSubmitting(true);
      try {
        await onContinue(country);
      } catch {
        // noop
      } finally {
        setSubmitting(false);
      }
    }
  }
  return (
    <StepWizard.StepPageLayout
      headerRender={() => (
        <HeaderText>Where do you live most of the time?</HeaderText>
      )}
      backUrl={backUrl}
    >
      <div className="px-5">
        <HeaderDescription>
          By law, we may need to as for proof of your address
        </HeaderDescription>
        <form onSubmit={submitHandler}>
          <BodyContainer className="mt-10">
            <ComboBox<Country>
              buttonChildren={(val) =>
                val ? (
                  <div>{val.name}</div>
                ) : (
                  <div className="text-gray-400">Select Your Country</div>
                )
              }
              buttonClassName="ring-black ring-1 hover:ring-2 rounded-lg w-full min-h-8 px-3 py-3"
              getOptions={(query) =>
                countries.filter((c) =>
                  c.name.toLowerCase().includes(query.toLowerCase()),
                )
              }
              onChange={(x) => setCountry(x)}
              renderItems={(options) => (
                <div>
                  {" "}
                  {options.map((opt) => (
                    <ComboboxOption key={opt.countryCode} value={opt}>
                      {({ focus, selected }) => (
                        <ComboOption active={focus} selected={selected}>
                          <div>{opt.name}</div>
                        </ComboOption>
                      )}
                    </ComboboxOption>
                  ))}
                </div>
              )}
              value={country}
            />
            <Button className="mt-10 w-full" loading={submitting} vSize="lg">
              Next
            </Button>
          </BodyContainer>
        </form>
      </div>
    </StepWizard.StepPageLayout>
  );
}
